import createCachedSelector from 're-reselect';

// eslint-disable-next-line import/prefer-default-export
export const createChannelSelector = (...args) => createCachedSelector(
	...args,
)((_, { hashtag }) => hashtag);
